import RadioButtonInput from './RadioButtonInput'

export default RadioButtonInput



// WEBPACK FOOTER //
// ./src/legacy/containers/Forms/components/RadioButtonInput/index.js